import React from 'react'
import { ICSDrawerContents } from "@ntg/component-library/declarations";
import HomeIcon from "@mui/icons-material/Home";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import PortraitIcon from "@mui/icons-material/Portrait";

export const DrawerContents: ICSDrawerContents = {
    Items: [
        {
            DrawerItems: [
                {
                    Icon: <HomeIcon color="secondary" />,
                    PrimaryText: "Home",
                    ShowMobile: true,
                    To: "/home",
                }
            ],
            ShowTitle: false,
            Title: "",
        },
        {
            DrawerItems: [
                {
                    Icon: <PortraitIcon color="secondary" />,
                    PrimaryText: "Users",
                    ShowMobile: true,
                    To: "/users",
                }
            ],
            ShowTitle: true,
            Title: "USERS",
        },
        {
            DrawerItems: [
                {
                    Icon: <PhotoLibraryIcon color="secondary" />,
                    PrimaryText: "User Logins",
                    ShowMobile: true,
                    To: "/userLogins",
                }
            ],
            ShowTitle: true,
            Title: "User Logins",
        }
    ]
};